import React, { useEffect, useState, useRef } from 'react';
import DataTable from 'react-data-table-component';
import { toast } from 'react-toastify';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../assets/css/JobModalCss.css';
import { Button, Modal, Form } from 'react-bootstrap';
import {
    createDeviceModelGroup, getAllCatalogs, getDeviceModelGroups, getDeviceModelGroupById,
    updateDeviceModelGroup, deleteDeviceModelGroupById, getCategoriesByCatalogId
} from '../commonApi';
import ActionCell from '../Utils/ActionCell';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { Loader } from '../Loader';

const DeviceModelGroup = () => {
    const [searchValue, setSearchValue] = useState('');
    const [page, setPage] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [sortField, setSortField] = useState('id');
    const [sortOrder, setSortOrder] = useState('desc');
    const [totalRows, setTotalRows] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [name, setName] = useState('');
    const [key, setKey] = useState('');
    const [description, setDescription] = useState('');
    const [selectedCatalogId, setSelectedCatalogId] = useState('');
    const [categoryId, setCategoryId] = useState('');
    const [catalogs, setCatalogs] = useState([]);
    const [catalogsName, setCatalogsName] = useState([]);
    const [categoryName, setCategoryName] = useState([]);
    const [categories, setCategories] = useState([]);
    const [deviceModelGroups, setDeviceModelGroups] = useState([]);
    const [validationErrors, setValidationErrors] = useState({
        name: '',
        key: '',
        description: '',
        categoryId: ''
    });
    const [editMode, setEditMode] = useState(false);
    const [currentGroupId, setCurrentGroupId] = useState(null);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [isSaveDisabled, setIsSaveDisabled] = useState(false);
    const [isDeleteDisabled, setIsDeleteDisabled] = useState(false);
    const [loading, setLoading] = useState(true);
    const saveButtonRef = useRef(null);
    const expectedPageRef = useRef(0);

    const renderActionCell = (row) => {
        return <ActionCell row={row} onEdit={handleEditClick} onDelete={handleDeleteClick} />;
    };
    const columns = [
        {
            name: 'Name',
            selector: row => row.name || <span style={{ position: 'absolute', left: '58px', top: '18px' }}>—</span>,
            sortable: true,
            sortField: 'name',
            width: "300px"
        },
        {
            name: 'Description',
            selector: row => row.description || <span style={{ position: 'absolute', left: '58px', top: '18px' }}>—</span>,
            sortable: true,
            sortField: 'description',
            width: "400px"
        },
        {
            name: 'Device Model Group Key',
            selector: row => row.key || <span style={{ position: 'absolute', left: '58px', top: '18px' }}>â€”</span>,
            sortable: true,
            sortField: 'key',
            width: "200px"
        },
        {
            name: 'Category Name',
            selector: row => row.categoryName || <span style={{ position: 'absolute', left: '58px', top: '18px' }}>—</span>,
            sortable: true,
            sortField: 'categoryName',
            width: "460px"
        },
        {
            name: 'Actions',
            cell: renderActionCell,
        },
    ];

    const fetchCatalogs = async () => {
        try {
            const response = await getAllCatalogs(0, 100, 'id', 'asc', '');
            setCatalogs(response?.data?.data?.content || []);
        } catch (error) {
            toast.error("Failed to fetch catalogs");
        }
    };

    const fetchCategories = async (catalogId) => {
        if (!catalogId) {
            setCategories([]);
            return;
        }
        try {
            const response = await getCategoriesByCatalogId(catalogId, 0, 100, 'id', 'asc');
            setCategories(response?.data?.data?.content || []);
        } catch (error) {
            toast.error("Failed to fetch categories");
        }
    };

    const fetchDeviceModelGroups = async () => {
        setLoading(true);
        try {
            const response = await getDeviceModelGroups(page, perPage, sortField, sortOrder, searchValue);
            const groups = (response?.data?.data?.content || []).filter(
                (group) => group && typeof group === "object" && group.id
            );
            setDeviceModelGroups(groups);
            setTotalRows(response?.data?.data?.totalElements || 0);
        } catch (error) {
            toast.error("Failed to fetch device model groups");
        } finally {
            setLoading(false);
        }
    };

    const handlePageChange = (newPage) => {
        setPage(newPage - 1);
        expectedPageRef.current = newPage - 1;
    };

    const handlePerRowsChange = (newPerPage) => {
        setPerPage(newPerPage);
        setPage(0);
        expectedPageRef.current = 0;
    };

    const handleSort = (column, sortDirection) => {
        const sortFieldCol = column.sortField || column.selector || 'id';
        setSortField(sortFieldCol);
        setSortOrder(sortDirection);
        setPage(0);
        expectedPageRef.current = 0;
    };

    const handleSearch = (event) => {
        setSearchValue(event.target.value);
        setPage(0);
        expectedPageRef.current = 0;
    };

    const handleAddNewClick = () => {
        setShowModal(true);
        setEditMode(false);
        fetchCatalogs();
    };

    const handleDeleteClick = (id) => {
        setDeleteId(id);
        setShowConfirmModal(true);
    };

    const confirmDelete = async () => {
        if (isDeleteDisabled) return;

        setIsDeleteDisabled(true);

        try {
            await deleteDeviceModelGroupById(deleteId);
            toast.success("Device Model Group deleted successfully!");
            setPage(0);
            expectedPageRef.current = 0;
            await fetchDeviceModelGroups();
        } catch (error) {
            toast.error(error?.response?.data?.error?.code || "Failed to delete Device Model Group");
        } finally {
            setIsDeleteDisabled(false);
            setDeleteId(null);
            setShowConfirmModal(false);
        }
    };

    const handleEditClick = async (id) => {
        setCurrentGroupId(id);
        setShowModal(true);
        setEditMode(true);

        try {
            const response = await getDeviceModelGroupById(id);
            const { name, description, key, catalogId, categoryId, catelogName, categoryName } = response.data.data;

            setName(name);
            setKey(key);
            setDescription(description);
            setSelectedCatalogId(catalogId);
            setCategoryId(categoryId);
            setCatalogsName(catelogName);
            setCategoryName(categoryName);
            fetchCatalogs();
            fetchCategories(catalogId);
        } catch (error) {
            toast.error("Failed to fetch device model group");
        }
    };

    const handleCatalogChange = (event) => {
        const catalogId = event.target.value;
        setSelectedCatalogId(catalogId);
        setCategoryId('');
        fetchCategories(catalogId);
    };

    const handleModalClose = () => {
        setShowModal(false);
        setValidationErrors({
            name: '',
            key: '',
            description: '',
            categoryId: ''
        });
        setName('');
        setKey('');
        setDescription('');
        setSelectedCatalogId('');

        if (!editMode) {
            setCategoryId('');
        }

        setCurrentGroupId(null);
    };

    const validateForm = () => {
        let isValid = true;
        const errors = {};

        if (!name) {
            errors.name = 'Name is required';
            isValid = false;
        }

        else if (name.length < 3 || name.length > 20) {
            errors.name = 'Name must be between 3 and 20 characters (including spaces)';
            isValid = false;
        }

        else if (!/^[a-zA-Z0-9 ]+$/.test(name)) {
            errors.name = 'Name can only contain letters, numbers, and spaces';
            isValid = false;
        }

        if (!editMode && !selectedCatalogId) {
            errors.selectedCatalogId = 'Catalog is required';
            isValid = false;
        }
        if (!editMode && !categoryId) {
            errors.categoryId = 'Category Id is required';
            isValid = false;
        }
        if (!key || !key.trim()) {
            errors.key = 'Key is required.';
            isValid = false;
        }

        setValidationErrors(errors);
        return isValid;
    };

    const handleSave = async () => {
        if (!validateForm()) {
            return;
        }

        if (isSaveDisabled || (saveButtonRef.current && saveButtonRef.current.disabled)) return;

        if (saveButtonRef.current) {
            saveButtonRef.current.disabled = true;
        }
        setIsSaveDisabled(true);

        const groupSaveDto = { name, key, description, categoryId };
        try {
            if (editMode && currentGroupId) {
                await updateDeviceModelGroup(currentGroupId, groupSaveDto);
                toast.success("Device Model Group updated successfully!");
            } else {
                await createDeviceModelGroup(categoryId, groupSaveDto);
                toast.success("Device Model Group created successfully!");
            }
            setPage(0);
            expectedPageRef.current = 0;
            handleModalClose();
            await fetchDeviceModelGroups();
        } catch (error) {
            toast.error(error?.response?.data?.error?.details || "Failed to save Device Model Group");
        } finally {
            if (saveButtonRef.current) {
                saveButtonRef.current.disabled = false;
            }
            setIsSaveDisabled(false);
        }
    };

    useEffect(() => {
        let isCancelled = false;

        const loadData = async () => {
            setLoading(true);
            try {
                if (!isCancelled) {
                    await fetchDeviceModelGroups();
                }
            } catch (error) {
                if (!isCancelled) {
                    toast.error("Failed to fetch device model groups");
                }
            } finally {
                if (!isCancelled) {
                    setLoading(false);
                }
            }
        };

        loadData();
        return () => {
            isCancelled = true;
        };
    }, [page, perPage, sortField, sortOrder, searchValue]);

    return (
        <div className="custom_tab_wrapper">
            {/* Inline CSS */}
            <style>
                {`
          .btn_red {
            background-color: #dc3545; /* Default red */
            border-color: #dc3545;
            color: white;
          }
          .btn_red:disabled {
            background-color: #f28b94; /* Light red for Deleting... */
            border-color: #f28b94;
            color: white;
            opacity: 0.8;
          }
          .btn_light__red {
            background-color: #f8d7da; /* Light red background for Cancel */
            border-color: #f5c6cb;
            color: #721c24;
          }
          .btn_light__red:disabled {
            background-color: #f8d7da; /* Same color when disabled */
            border-color: #f5c6cb;
            color: #721c24;
            opacity: 0.65; /* Bootstrap default opacity for disabled */
          }
        `}
            </style>

            <div className="tab-content" id="myTabContent">
                <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                    <ul className="nav nav-tabs" id="myTab" >
                        <li className="nav-item" >
                            <button
                                className="nav-link active"
                                id="home-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#home"
                                type="button"
                                role="tab"
                                aria-controls="home"
                                aria-selected="true"
                            >
                                Device Model Groups: {totalRows}
                            </button>
                        </li>
                    </ul>
                    <div className="tab-content" id="myTabContent">
                        <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                            <div className="tab_content_wrapper full_height_tab">
                                <div className="custom_table_action">
                                    <div>
                                        <input
                                            className="form-control"
                                            type="text"
                                            placeholder="Search"
                                            value={searchValue}
                                            onChange={handleSearch}
                                        />
                                    </div>
                                    <div>
                                        <button
                                            className="btn btn-primary"
                                            onClick={handleAddNewClick}
                                            aria-label="Add New Device Model Group"
                                            style={{ backgroundColor: '#4340d2' }}
                                            data-bs-toggle="tooltip"
                                            data-bs-placement="left"
                                            title="Add New"
                                        >
                                            <FontAwesomeIcon icon={faPlus} />
                                        </button>
                                    </div>
                                </div>
                                <div className="table-responsive h-100vh-150px">
                                    {loading ? (
                                        <div className="spin-loader">
                                            <Loader />
                                        </div>
                                    ) : (
                                        <div className="custom_table customs-table">
                                            <DataTable
                                                columns={columns}
                                                data={deviceModelGroups}
                                                pagination
                                                paginationServer
                                                paginationTotalRows={totalRows}
                                                paginationPerPage={perPage}
                                                paginationDefaultPage={page + 1}
                                                onChangePage={handlePageChange}
                                                onChangeRowsPerPage={handlePerRowsChange}
                                                onSort={handleSort}
                                                defaultSortFieldId={sortField}
                                                defaultSortAsc={sortOrder === 'asc'}
                                                sortServer
                                                fixedHeader
                                                fixedHeaderScrollHeight="440px"
                                            />
                                        </div>
                                    )}
                                </div>
                                <Modal show={showModal} onHide={handleModalClose}>
                                    <Modal.Header closeButton>
                                        <Modal.Title style={{ color: "#4340d2" }}>{editMode ? 'Edit Device Model Group' : 'Add Device Model Group'}</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <Form>
                                            <Form.Group className="mb-3">
                                                <Form.Label htmlFor="catalog-input">Catalog<span className="required-asterisk" style={{ color: "red" }}>*</span></Form.Label>
                                                {editMode ? (
                                                    <Form.Control
                                                        id="catalog-input"
                                                        type='text'
                                                        value={catalogsName}
                                                        disabled={true}
                                                    />
                                                ) : (
                                                    <Form.Control
                                                        id="catalog-input"
                                                        as="select"
                                                        value={selectedCatalogId}
                                                        onChange={handleCatalogChange}
                                                        isInvalid={!!validationErrors.selectedCatalogId}
                                                    >
                                                        <option value="">Select Catalog</option>
                                                        {catalogs.map(catalog => (
                                                            <option key={catalog.id} value={catalog.id}>
                                                                {catalog.catalogName}
                                                            </option>
                                                        ))}
                                                    </Form.Control>
                                                )}
                                                <Form.Control.Feedback type="invalid">
                                                    {validationErrors.selectedCatalogId}
                                                </Form.Control.Feedback>
                                            </Form.Group>

                                            <Form.Group className="mb-3">
                                                <Form.Label htmlFor="category-input">Category<span className="required-asterisk" style={{ color: "red" }}>*</span></Form.Label>
                                                {editMode ? (
                                                    <Form.Control
                                                        id="category-input"
                                                        type='text'
                                                        value={categoryName}
                                                        disabled={true}
                                                    />
                                                ) : (
                                                    <Form.Control
                                                        id="category-input"
                                                        as="select"
                                                        value={categoryId}
                                                        onChange={(e) => setCategoryId(e.target.value)}
                                                        isInvalid={!!validationErrors.categoryId}
                                                        disabled={!selectedCatalogId}
                                                    >
                                                        <option value="">Select Category</option>
                                                        {categories.map(category => (
                                                            <option key={category.id} value={category.id}>
                                                                {category.name}
                                                            </option>
                                                        ))}
                                                    </Form.Control>
                                                )}
                                                <Form.Control.Feedback type="invalid">
                                                    {validationErrors.categoryId}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                            <Form.Group className="mb-3">
                                                <Form.Label htmlFor="name-input">Name<span className="required-asterisk" style={{ color: "red" }}>*</span></Form.Label>
                                                <Form.Control
                                                    id="name-input"
                                                    type="text"
                                                    placeholder="Enter name"
                                                    value={name}
                                                    onChange={(e) => setName(e.target.value)}
                                                    isInvalid={!!validationErrors.name}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {validationErrors.name}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                            <Form.Group className="mb-3">
                                                <Form.Label htmlFor="key-input">Device Model Group Key<span className="required-asterisk" style={{ color: "red" }}>*</span></Form.Label>
                                                <Form.Control
                                                    id="key-input"
                                                    type="text"
                                                    placeholder="Enter device model group key"
                                                    value={key}
                                                    onChange={(e) => setKey(e.target.value)}
                                                    isInvalid={!!validationErrors.key}
                                                    disabled={editMode}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {validationErrors.key}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                            <Form.Group className="mb-3">
                                                <Form.Label htmlFor="description-input">Description</Form.Label>
                                                <Form.Control
                                                    id="description-input"
                                                    as="textarea"
                                                    rows={3}
                                                    placeholder="Enter description"
                                                    value={description}
                                                    onChange={(e) => setDescription(e.target.value)}
                                                    isInvalid={!!validationErrors.description}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {validationErrors.description}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Form>
                                    </Modal.Body>

                                    <Modal.Footer>
                                        <Button className="btn light_primary_btn me-3" onClick={handleModalClose}>
                                            Cancel
                                        </Button>
                                        <Button
                                            className="btn primary_btn"
                                            type='submit'
                                            onClick={handleSave}
                                            ref={saveButtonRef}
                                            disabled={isSaveDisabled}
                                        >
                                            {isSaveDisabled ? "Saving..." : "Save"}
                                        </Button>
                                    </Modal.Footer>
                                </Modal>

                                {/* Confirmation Modal */}
                                {showConfirmModal && (
                                    <div
                                        className="modal fade discard_modal show"
                                        id="delete-model"
                                        style={{ display: 'block' }}
                                        aria-hidden={!showConfirmModal}
                                        aria-labelledby="exampleModalToggleLabel"
                                        tabIndex="-1"
                                    >
                                        <div className="modal-dialog modal-dialog-centered">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <p className="modal-title" id="staticBackdropLabel">
                                                        Delete Device Model Group
                                                    </p>
                                                </div>
                                                <div className="modal-body">
                                                    <p className="modal-msg-title">Confirm Delete</p>
                                                    <p className="modal-msg-desc">Are you sure you want to delete this device model group?</p>
                                                </div>
                                                <div className="modal-footer">
                                                    <button
                                                        className="btn btn_light__red mx-2"
                                                        onClick={() => setShowConfirmModal(false)}
                                                        disabled={isDeleteDisabled}
                                                    >
                                                        Cancel
                                                    </button>
                                                    <button
                                                        className="btn btn_red btn-loader"
                                                        onClick={confirmDelete}
                                                        disabled={isDeleteDisabled}
                                                    >
                                                        {isDeleteDisabled ? "Deleting..." : "Delete"}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeviceModelGroup;